import { z } from 'my-zod'
import { addOnProductModel } from './add-on-product-model'

export const addOnProductSystemView = addOnProductModel

export type addOnProductSystemView = z.infer<typeof addOnProductSystemView>
